module.exports = __webpack_public_path__ + "static/other/collage-interview.5fabbfa8.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/collage-interview.json
// module id = 2264
// module chunks = 0